import QuantLabPage from "./QuantLabPage";

export default QuantLabPage;
